import { CommunityType } from './types'

interface CommunityProps {
  community: CommunityType
}

export default function Community({ community }: CommunityProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Name:</strong>
        {community.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Location:</strong>
        {community.location?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Mayor:</strong>
        {community.mayor?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Phone:</strong>
        {community.phone?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Email:</strong>
        {community.email?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {community.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Latitude:</strong>
        {community.latitude?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Longitude:</strong>
        {community.longitude?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Status:</strong>
        {community.status?.toString()}
      </p>
    </div>
  )
}
